// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__m8Vdf","canvas":"Layout_canvas__zPsGp","contentStack":"Layout_contentStack__I7P0h"};